import { GridRow } from 'ui/indexPages/tables/grid';
import { CheckboxGridCell } from 'ui/indexPages/tables/cells';
import { Skeleton } from 'ui/skeleton';
import { CHECKBOX_STATUS } from 'ui/checkbox';
import { TABLE_GRID } from '../constants';
import { Cell, NameCell, RadioContainer } from './TableRow';
import { Radio } from 'ui/radio';
const skeletonRows = 10;

export const testIds = {
  skeleton: 'cl-index-table-skeleton',
};

export const TableSkeleton = ({ isPanel }: { isPanel: boolean }) => (
  <div data-test={testIds.skeleton}>
    {Array(skeletonRows)
      .fill({})
      .map((r, i) => (
        <GridRow gridLayout={TABLE_GRID} key={`grid-row-${i}`}>
          {isPanel ? (
            <RadioContainer>
              <Radio value={false} onClick={() => null} />
            </RadioContainer>
          ) : (
            <CheckboxGridCell id={i} status={CHECKBOX_STATUS.UNCHECKED} handleClick={() => null} />
          )}
          <NameCell>
            <Skeleton height={32} />
          </NameCell>
          <Cell>
            <Skeleton height={32} />
          </Cell>
          <Cell>
            <Skeleton height={32} />
          </Cell>
        </GridRow>
      ))}
  </div>
);
